













































import { defineComponent, PropType } from '@vue/composition-api'

// models
import { WorkDescriptionPieceworkInput } from '@/models/piecework'
import { WorkDescriptionModel } from '@/models/config'

/// components
import { Input } from '@/components/general'

export default defineComponent({
  name: 'WorkDescriptionsTable',
  components: {
    Input
  },
  props: {
    items: {
      type: Array as PropType<WorkDescriptionPieceworkInput[]>,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    workDescriptions: {
      type: Array as PropType<WorkDescriptionModel[]>,
      required: true
    }
  },
  setup (props) {
    const getName = (id: number) => {
      const item = props.workDescriptions.find(w => w.id === id)
      if (item) {
        return item.name
      }
      return ''
    }

    return {
      getName
    }
  }
})
